export default __webpack_public_path__ + "static/media/misc-books2-1024w.4e8bed40.avif";